import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", {
  style: {"margin-left":"10px","text-align":"left"},
  class: "ss-titulo"
}, "Vendas", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-3 ant-col-xs-24 ant-col-lg-6" }, null, -1)
const _hoisted_5 = {
  class: "ant-col ant-col-xl-3 ant-col-xs-3 ss-ocultar-mobile",
  style: {"padding-right":"10px"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Produto :", -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Tipo Produção :", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Data Criação:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Data Inicio :", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", null, "Data Conclusão :", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Status :", -1)
const _hoisted_20 = { class: "acoes-item ss-alinhar-centro" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_26 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_27 = { class: "ant-input-suffix" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1)
const _hoisted_29 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "titulo", {}, () => [
          _hoisted_3
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.computedVisualizacaoKanban,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedVisualizacaoKanban) = $event)),
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, {
              value: true,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "mapa" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, {
              value: false,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "menu" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_component_a_table, {
      style: {"margin-top":"5px"},
      columns: _ctx.state.colunas.filter(item => item.visible),
      "data-source": _ctx.computedOps,
      rowKey: "codigo",
      pagination: false,
      loading: _ctx.telaBase.carregando,
      scroll: { x: (_ctx.gradeBase.windowWidth), y: _ctx.defineAlturaScroll(50) },
      "row-selection": { selectedRowKeys: _ctx.computedSelecionados, onChange: _ctx.mudarSelecao },
      size: "small"
    }, {
      headerCell: _withCtx(({ column }) => [
        _createVNode(_component_coluna_grade, {
          column: column,
          ordenacaoSelecionada: _ctx.gradeBase.ordenacaoSelecionada,
          "onUpdate:ordenacaoSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
          filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
          "onUpdate:filtrosCabecalho": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
          onBuscarDados: _ctx.buscarOpsCabecalho
        }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
      ]),
      bodyCell: _withCtx(({ column, record, text }) => [
        (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: ($event: any) => (_ctx.visualizar(record.codigo))
            }, [
              _createElementVNode("span", null, _toDisplayString(text), 1)
            ], 8, _hoisted_6))
          : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: "visualizar",
                  onClick: ($event: any) => (_ctx.visualizar(record.codigo))
                }, [
                  _createVNode(_component_icone, { nome: "visualizar" })
                ], 8, _hoisted_8),
                (_ctx.obterStatus(record.status)==='pendente')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.excluir(record)),
                      class: "excluir"
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]))
            : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                : (column.key === 'Status')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_a_tag, {
                        title: text,
                        class: _normalizeClass('ss-tag-status op-' + _ctx.obterStatus(record.status))
                      }, null, 8, ["title", "class"]),
                      _createTextVNode(_toDisplayString(text), 1)
                    ], 64))
                  : (column.key === 'Codigo')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", null, [
                          _hoisted_13,
                          _createTextVNode(),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.visualizar(record.codigo))
                          }, _toDisplayString(record.descricao), 9, _hoisted_14)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_15,
                          _createTextVNode(" " + _toDisplayString(record.tipoProducao), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(record.dataCriacao), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(record.dataInicio), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(record.dataConclusao), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(record.descricaoSelecionado), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("a", {
                            class: "visualizar",
                            onClick: ($event: any) => (_ctx.visualizar(record.codigo))
                          }, [
                            _createVNode(_component_icone, { nome: "visualizar" })
                          ], 8, _hoisted_21),
                          (_ctx.obterStatus(record.status)==='pendente')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.excluir(record)),
                                class: "excluir"
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createTextVNode(_toDisplayString(text), 1)
                      ], 64))
      ]),
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, {
          resultadoPesquisa: !_ctx.telaBase.carregando,
          mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
        }, null, 8, ["resultadoPesquisa", "mensagem"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_a_pagination, {
          class: "ss-paginacao-completa",
          current: _ctx.computedPaginacao.current,
          "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedPaginacao.current) = $event)),
          size: "small",
          total: _ctx.props.ops.length,
          "show-total": _ctx.mostrarTotalPaginacao,
          "page-size": _ctx.computedPaginacao.pageSize,
          pageSizeOptions: _ctx.computedPaginacao.pageSizeOptions,
          onShowSizeChange: _ctx.mostrarNovaPagina,
          onChange: _ctx.mudarPagina
        }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
            onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.keyupQuantidadeRegistroTotal && _ctx.keyupQuantidadeRegistroTotal(...args))),
            placeholder: "Total registros",
            type: "text",
            class: "ant-input hidden"
          }, null, 544), [
            [_vModelText, _ctx.state.totalRegistrosComMascara],
            [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
          ]),
          _createElementVNode("span", _hoisted_27, [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_28
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_29, [
                  _createVNode(_component_icone, { nome: "informacoes" })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}